import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-bootstrap/Form";
import logoImage from "../../../assets/Images/loginlogo.png";
import background from "../../../assets/Images/loginbg.png";
import { Link, Redirect } from "react-router-dom";
import { teacherSignUp } from "../../../redux/Teacher/user/action";
import Lottie from 'react-lottie';
import animationData from '../../../assets/lottie/login1.json';
class TeacherLogin extends Component {
    state = {
        user_id: "",
        password: "",
        invalid: false,
        login: false,
    };
    handleInputPassword = (e) => {
        this.setState({ password: e.target.value });
    };
    handleInputEmail = (e) => {
        this.setState({ user_id: e.target.value });
    };
    onSubmit = (e) => {
        this.setState({ login: true })
        e.preventDefault();
        this.props
            .teacherSignUp(this.state.user_id, this.state.password)
            .then((response) => {
                if (
                    response.payload.success === false &&
                    response.payload.data === "Invalid User ID or Password"
                ) {
                    this.setState({ login: false,invalid: true });
                }
                else if (response.payload.success) {
                    window.location.replace("/teacher-home");
                }
            });
    };
    render() {
        const { user } = this.props;
        if (user?.success) {
            return <Redirect to={"/teacher-home"} />;
        }
        return (
            <React.Fragment>
                {this.state.login ? (
                    <React.Fragment>
                        <div style={{ height: '100vh' }} className="d-flex justify-content-center align-items-center">
                            <Lottie
                                options={defaultOptions}
                                height={240}
                                width={250}
                            />
                        </div>
                    </React.Fragment>
                ) : (
                    <div
                        className="d-flex flex-column "
                        style={{
                            backgroundImage: `url(${background})`,
                            height: "100vh",
                            backgroundSize: "cover",
                            width: "100%",
                        }}
                    >
                        <div className="logo-image mb-5">
                            <img src={logoImage} alt="logo" width="100px" height="100px" />
                        </div>
                        {this.state.invalid ? (
                            <span className="text-white p-2 text-center">
                                Invalid User ID or Password
                            </span>
                        ) : null}
                        <div className="login-form">
                            <Form
                                className="mt-3 text-white"
                                onSubmit={(e) => this.onSubmit(e)}
                            >
                                <input
                                    type="text"
                                    className="username-input-login w-100"
                                    placeholder="User ID"
                                    required
                                    onChange={(e) => {
                                        this.handleInputEmail(e);
                                    }}
                                />
                                <input
                                    type="password"
                                    placeholder="Password"
                                    required
                                    className="username-input-login mt-4 w-100"
                                    onChange={(e) => {
                                        this.handleInputPassword(e);
                                    }}
                                />
                                <div className="login-btn-div">
                                    <button
                                        type="submit"
                                        className="login-button w-100"
                                        size="lg"
                                        style={{ fontSize: "16px" }}
                                    >
                                        Log In
                                    </button>
                                </div>
                            </Form>
                            {/* <div className="forget-link">
                            <Link
                                to="/home"
                                style={{
                                    color: "white",
                                    textDecoration: "underline",
                                }}
                            >
                                Forget username or password
                            </Link>
                        </div> */}
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.teacher.teacher
});

export default connect(mapStateToProps, { teacherSignUp })(TeacherLogin);
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};
